module.exports = __webpack_public_path__ + "static/media/google-icon.686f8efa.svg";